export const PAYMENT_ANALYTICS_BY_DATE_YAML = () => `paymentAnalytic:
  start: "2022-01-18"
  end: "2022-01-27"`;
